module.exports = __webpack_public_path__ + "static/media/vampire-diaries.84b0a06e.jpg";